import React from 'react';
import { ImageFile } from '~/data/types/images';

const LocationIconIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.08329 7.75173C9.08329 6.60067 8.1506 5.66797 7.00038 5.66797C5.84932 5.66797 4.91663 6.60067 4.91663 7.75173C4.91663 8.90194 5.84932 9.83464 7.00038 9.83464C8.1506 9.83464 9.08329 8.90194 9.08329 7.75173Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99959 16.5C6.00086 16.5 0.75 12.2486 0.75 7.80274C0.75 4.3222 3.54758 1.5 6.99959 1.5C10.4516 1.5 13.25 4.3222 13.25 7.80274C13.25 12.2486 7.99832 16.5 6.99959 16.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Component>
  );
};

export default LocationIconIcon;
